import React from 'react'
import Tree, { useTreeState } from 'react-hyper-tree'

interface TreeNode {
  name: string,
  children?: TreeNode[]
  [key: string]: unknown
}

interface Props {
  name: string,
  data: TreeNode[]
}

const Treeable: React.FC<Props> = ({ name, data }) => {
  const { required, handlers } = useTreeState({
    data,
    id: name,
    defaultOpened: true
  })

  return (
    <Tree
      {...required}
      {...handlers}
    />
  )
}

export default Treeable
